export default __webpack_public_path__ + "static/media/set_6_Page-5.75a78e9d.svg";